import {gql} from '@apollo/client';

export const SEND_REQUEST_MUTATION = gql`
	mutation (
		$message: String!
		$telNumber: String!
		$name: String!
	) {
		createRequest(data: {
			from: SHOP
			message: $message
			telNumber: $telNumber
			name: $name
		}) {
			id
		}
	}
`;

export const ADD_PRODUCT_REVIEW_QUERY = gql`
	mutation (
		$productId: Int!
		$value: Int!
		$comment: String!
	) {
		createProductReview(
			data: {
				productId: $productId
				value: $value
				comment: $comment
			}
		) {
			id
			client {
				email
				fullName
				image
				clientType
			}
			value
			comment
			createdAt
		}
	}
`;

export const ADD_PRODUCT_REVIEW_REPLY_QUERY = gql`
	mutation (
		$productReviewId: Int!
		$comment: String!
	) {
		createProductReviewReply(
			data: {
				productReviewId: $productReviewId
				comment: $comment
			}
		) {
			id
			client {
				email
				fullName
				image
				clientType
			}
			comment
			createdAt
		}
	}
`;

export const EDIT_PRODUCT_REVIEW_QUERY = gql`
	mutation (
		$id: Int!
		$value: Int!
		$comment: String!
	) {
		updateProductReviewSelf(
			data: {
				id: $id
				value: $value
				comment: $comment
			}
		)
	}
`;

export const EDIT_PRODUCT_REVIEW_REPLY_QUERY = gql`
	mutation (
		$id: Int!
		$comment: String!
	) {
		updateProductReviewReplySelf(
			data: {
				id: $id
				comment: $comment
			}
		)
	}
`;

export const DELETE_PRODUCT_REVIEW_QUERY = gql`
	mutation (
		$id: Int!
	) {
		deleteProductReviewSelf(
			id: $id
		)
	}
`;

export const DELETE_PRODUCT_REVIEW_REPLY_QUERY = gql`
	mutation (
		$id: Int!
	) {
		deleteProductReviewReplySelf(
			id: $id
		)
	}
`;
